export default __webpack_public_path__ + "static/media/saving-piggy.af8b5d6b.svg";